/* eslint-disable complexity */
// eslint-disable-next-line no-restricted-imports
import { css } from "@compiled/react";

import { getColor, ExportableAdgColorTypes } from "./adg-colors";
import { AddUser } from "./icons/avatar/add-user";
import { LongHair } from "./icons/avatar/long-hair";
import { Checkmark as CheckmarkBasic } from "./icons/basic/checkmark";
import { CheckmarkCircle } from "./icons/basic/checkmark-circle";
import { Cross } from "./icons/basic/cross";
import { InfoCircle } from "./icons/basic/info-circle";
import { No } from "./icons/basic/no";
import { Accelerator } from "./icons/content/accelerator";
import { Checkmark } from "./icons/content/checkmark";
import { DiagramOrgChart } from "./icons/content/diagram-org-chart";
import { Lightning } from "./icons/content/lightning";
import { Maximize } from "./icons/content/maximize";
import { PageMultiple } from "./icons/content/page-multiple";
import { Team } from "./icons/content/team";
import { Bold } from "./icons/object/bold";
import { Building } from "./icons/object/building";
import { LocationPin } from "./icons/object/location-pin";
import { PuzzlePiece } from "./icons/object/puzzle-piece";
import { SecurityCheckmark } from "./icons/object/security-checkmark";
import { Video } from "./icons/object/video";
import { Wrench } from "./icons/object/wrench";
import { CloudCheckmark } from "./icons/software/cloud-checkmark";
import { DataCenter } from "./icons/software/data-center";

const IconNames = [
    "adduser",
    "longhair",
    "checkmarkbasic",
    "checkmark",
    "checkmarkcircle",
    "cross",
    "no",
    "diagramorgchart",
    "maximize",
    "pagemultiple",
    "bold",
    "building",
    "puzzlepiece",
    "securitycheckmark",
    "locationpin",
    "video",
    "wrench",
    "cloudcheckmark",
    "datacenter",
    "accelerator",
    "team",
    "lightning",
    "info"
] as const;

export type IconNameTypes = (typeof IconNames)[number];

export interface IconProps {
    name: IconNameTypes;
    size?: "xs" | "small" | "medium" | "large";
    color?: ExportableAdgColorTypes;
}

const getIconSize = (size: string | undefined) => {
    switch (size) {
        case "xs":
            return "24px";
        case "small":
            return "32px";
        case "medium":
            return "48px";
        case "large":
            return "64px";
        default:
            return "48px";
    }
};

const basicStyle = css({
    lineHeight: 0
});

export const IconFetcher = (name: string, size?: string) => {
    const iconSize = getIconSize(size);
    switch (name.toLowerCase()) {
        // avatar
        case "adduser":
            return <AddUser size={iconSize} />;
        case "longhair":
            return <LongHair size={iconSize} />;

        // basic
        case "checkmarkbasic":
            return <CheckmarkBasic size={iconSize} />;
        case "checkmarkcircle":
            return <CheckmarkCircle size={iconSize} />;
        case "cross":
            return <Cross size={iconSize} />;
        case "no":
            return <No size={iconSize} />;
        case "infocircle":
            return <InfoCircle size={iconSize} />;

        // content
        case "checkmark":
            return <Checkmark size={iconSize} />;
        case "diagramorgchart":
            return <DiagramOrgChart size={iconSize} />;
        case "maximize":
            return <Maximize size={iconSize} />;
        case "pagemultiple":
            return <PageMultiple size={iconSize} />;

        // object
        case "bold":
            return <Bold size={iconSize} />;
        case "building":
            return <Building size={iconSize} />;
        case "puzzlepiece":
            return <PuzzlePiece size={iconSize} />;
        case "securitycheckmark":
            return <SecurityCheckmark size={iconSize} />;
        case "locationpin":
            return <LocationPin size={iconSize} />;
        case "video":
            return <Video size={iconSize} />;
        case "wrench":
            return <Wrench size={iconSize} />;
        case "accelerator":
            return <Accelerator size={iconSize} />;
        case "team":
            return <Team size={iconSize} />;
        case "lightning":
            return <Lightning size={iconSize} />;

        // software
        case "cloudcheckmark":
            return <CloudCheckmark size={iconSize} />;
        case "datacenter":
            return <DataCenter size={iconSize} />;
        default:
            return null;
    }
};

export const Icon = ({ name, size, color }: IconProps) => {
    const iconColor = color ? getColor(color) : null;
    return (
        <div
            className="icon"
            css={basicStyle}
            style={{ color: iconColor ? iconColor : "inherit" }}
        >
            {IconFetcher(name, size)}
        </div>
    );
};
